module.exports = __webpack_public_path__ + "static/media/function.aa205598.svg";